import { DateTime } from "luxon";
import { type Asserts, array, boolean, mixed, object, string } from "yup";
import type { CampaignStatus } from "../enums";
import type { PersistedBlock } from "./blocks";

export const CampaignSchema = object({
  name: string().required("Campaign name is required"),
  subject: string(),
  showLogo: boolean(),
  bnBlocks: array().nullable(),
  scheduledAt: mixed()
    .nullable()
    .transform((value) => (value === null ? null : DateTime.fromISO(value))),
}).noUnknown();
export const CampaignWithSubjectSchema = object({
  subject: string().required("Subject is required"),
});

export type CampaignPayload = Asserts<typeof CampaignSchema>;

export type PersistedCampaign = CampaignPayload & {
  id: string;
  status: CampaignStatus;
  updatedAt: string;
  insertedAt: string;
  recipients: {
    totalCount: number;
    sendableCount: number;
    unsubscribedCount: number;
    contactGroupIds: string[];
    excludedContactGroupIds: string[];
    contactIds: string[];
  };
  url: string;
  sentAt: string | null;
  themeId: string;
  scheduledAt: string | null;
  bnBlocks: Record<string, unknown>[] | null;
};
export type PopulatedCampaign = PersistedCampaign & {
  blocks: PersistedBlock[];
};

export type PublicPopuledCampaign = {
  id: string;
  blocks: PersistedBlock[];
  showLogo: boolean;
  url: string;
};

export const EmptyCampaign: CampaignPayload = {
  name: "",
  subject: "",
};
